import { Action, SimpleAction } from 'Types/action'
import { ActionTypes } from 'Src/constants/ActionType.constants'
import {
	WidgetNames,
	DashboardParams,
	DashboardData,
	WidgetData,
	CapabilityModel,
	MOTIVATION_TYPES,
} from 'Pages/dashboard'
import { Callback } from 'Types/utilTypes'

const getDashboardDataAction = (): SimpleAction => ({
	type: ActionTypes.GET_DASHBOARD_DATA,
})

export type SET_DASHBOARD_DATA = Partial<DashboardData>
const setDashboardDataAction = (response: SET_DASHBOARD_DATA): Action<SET_DASHBOARD_DATA> => ({
	type: ActionTypes.SET_DASHBOARD_DATA,
	payload: response,
})

const clearDashboardDataAction = (): SimpleAction => ({
	type: ActionTypes.CLEAR_DASHBOARD_DATA,
})

export type SET_DASHBOARD_PARAMS = Partial<DashboardParams>
const setDashboardDateInfoAction = (
	data: Partial<DashboardParams>
): Action<SET_DASHBOARD_PARAMS> => ({
	type: ActionTypes.SET_DASHBOARD_PARAMS,
	payload: data,
})

export type GET_DASHBOARD_WIDGETS_DATA = WidgetNames[]
const getDashboardWidgetsDataAction = (
	widgets: GET_DASHBOARD_WIDGETS_DATA
): Action<GET_DASHBOARD_WIDGETS_DATA> => ({
	type: ActionTypes.GET_DASHBOARD_WIDGETS_DATA,
	payload: widgets,
})

export type SET_DASHBOARD_WIDGET_DATA = {
	widget_name: WidgetNames
	widget_data: WidgetData | {}
	dateInfo: DashboardParams
}

const setDashboardWidgetDataAction = (
	widget_name: WidgetNames,
	widget_data: WidgetData | {},
	dateInfo?: DashboardParams
): Action<SET_DASHBOARD_WIDGET_DATA> => ({
	type: ActionTypes.SET_DASHBOARD_WIDGET_DATA,
	payload: { widget_name, widget_data, dateInfo },
})

const getDashboardWidgetCapabilitiesDataFullAction = (): SimpleAction => ({
	type: ActionTypes.GET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL,
})

export type SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL = {
	from: string
	to: string
	values: CapabilityModel[]
}

const setDashboardWidgetCapabilitiesDataFullAction = (
	widgetData
): Action<SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL> => ({
	type: ActionTypes.SET_DASHBOARD_WIDGET_CAPABILITIES_DATA_FULL,
	payload: widgetData,
})

export type SET_OPENED_HEADER = null
const toggleHeaderAction = (): Action<SET_OPENED_HEADER> => ({
	type: ActionTypes.SET_OPENED_HEADER,
	payload: null,
})

// пометить на удаление
export type SET_DASHBOARD_PARTNER = number
const setDashboardPartnerIdAction = (partner_id: number): Action<SET_DASHBOARD_PARTNER> => ({
	type: ActionTypes.SET_DASHBOARD_PARTNER,
	payload: partner_id,
})

const showDashboardPartnerSelectAction = (): SimpleAction => ({
	type: ActionTypes.SHOW_DASHBOARD_PARTNER_SELECT,
})

export const hideDashboardPartnerSelectAction = (): SimpleAction => ({
	type: ActionTypes.HIDE_DASHBOARD_PARTNER_SELECT,
})

const showSigningActsAction = (): SimpleAction => ({
	type: ActionTypes.DASHBOARD_SHOW_SIGNING_ACTS,
})

const getDashboardAvailableProducts = (): SimpleAction => ({
	type: ActionTypes.GET_DASHBOARD_AVAILABLE_PRODUCTS,
})

export type SET_DASHBOARD_AVAILABLE_PRODUCTS = Record<number, string>
const setDashboardAvailableProducts = (
	data: SET_DASHBOARD_AVAILABLE_PRODUCTS
): Action<SET_DASHBOARD_AVAILABLE_PRODUCTS> => ({
	type: ActionTypes.SET_DASHBOARD_AVAILABLE_PRODUCTS,
	payload: data,
})

export type SET_DASHBOARD_WIDGETS_IS_LOADING = boolean
const setDashboardWidgetsIsLoading = (
	isLoading: SET_DASHBOARD_WIDGETS_IS_LOADING
): Action<SET_DASHBOARD_WIDGETS_IS_LOADING> => ({
	type: ActionTypes.SET_DASHBOARD_WIDGETS_IS_LOADING,
	payload: isLoading,
})

const showDashboardPartnerPayment = (): SimpleAction => ({
	type: ActionTypes.SHOW_DASHBOARD_PARTNER_PAYMENT,
})

export type UPDATE_MOTIVATION_WIDGET = { data: MOTIVATION_TYPES; callback: Callback }
const updateMotivationWidgetAction = (
	data: UPDATE_MOTIVATION_WIDGET
): Action<UPDATE_MOTIVATION_WIDGET> => ({
	type: ActionTypes.UPDATE_MOTIVATION_WIDGET,
	payload: data,
})

export const dashboardActions = {
	setDashboardWidgetDataAction,
	setDashboardPartnerIdAction,
	setDashboardDateInfoAction,
	setDashboardWidgetCapabilitiesDataFullAction,
	showDashboardPartnerSelectAction,
	setDashboardDataAction,
	clearDashboardDataAction,
	getDashboardDataAction,
	getDashboardWidgetsDataAction,
	showSigningActsAction,
	getDashboardAvailableProducts,
	setDashboardAvailableProducts,
	setDashboardWidgetsIsLoading,
	getDashboardWidgetCapabilitiesDataFullAction,
	toggleHeaderAction,
	showDashboardPartnerPayment,
	updateMotivationWidgetAction,
}
